import { Modal } from "@/ui/modals";
import SellBotActions from "@/pages/token-v2/modules/bot-actions/sell-bot-actions";
import TokenProvider from "@/pages/token-v2/providers/token-provider";

const TokenSellModal = ({
  isOpen,
  toggleOpen,
  tokenId,
}: {
  isOpen: boolean;
  toggleOpen: () => void;
  tokenId: string | null;
}) => {
  return (
    <TokenProvider tokenAddressAndChain={tokenId}>
      <Modal
        opened={isOpen}
        onClose={() => toggleOpen()}
        className="w-[21.438rem] bg-section-gradient text-white"
        onlyChildren
      >
        <SellBotActions />
      </Modal>
    </TokenProvider>
  );
};

export default TokenSellModal;
